module.exports = __webpack_public_path__ + "static/media/santafe.8a6b8fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/santafe.png
// module id = 627
// module chunks = 0